<template>
  <div class="is-flex flex-wrap-wrap" :class="{'margin-top-9':!isMobile, 'margin-top-11':isMobile, 'box-view':boxView }">
    <h4 v-if="boxView" class="has-text-weight-bold color-blue-dark">Business Performance <span class="has-text-weight-normal"> <span class="has-text-weight-normal">(Rolling 12 months):</span></span></h4>
    <hr class="separator" v-if="boxView"/>
    <div class="hp-card perf-card" v-if="trustIndex">
      <div class="perf-card__head">{{ trustIndex }}</div>
      <div>
        <span class="has-text-weight-bold">Trust</span>index Rating
      </div>
    </div>
    <hr class="separator" v-if="boxView && trustIndex"/>
    <div class="hp-card perf-card position-relative" v-if="topIndustry.rank">
      <div class="perf-card__head">#{{ topIndustry.rank }}</div>
      <div class="ellipsis">
        <span class="has-text-weight-bold">Ranked</span> In
        <router-link :to="topIndustry.url" class="link--v2">{{ topIndustry.name }}</router-link>
      </div>
      <tooltip v-if="industryRankingTooltipHtml" :iconRight="rankTooltipIconRightPos" :iconTop="6" :tooltipRight="rankTooltipRightPos" :tooltipTop="rankTooltipTopPos" tooltipClass="rankingTooltip" :openOnClick="true">
        <div v-html="industryRankingTooltipHtml"></div>
      </tooltip>
    </div>
    <hr class="separator" v-if="boxView && topIndustry.rank"/>
    <div class="hp-card perf-card" v-if="responseTime.value">
      <div class="perf-card__head">{{ responseTime.value }} <span class="font-size-11 has-text-weight-normal">{{ responseTime.unit }}</span></div>
      <div>
        <span class="has-text-weight-bold">Average</span> Time To Reply
      </div>
    </div>
    <hr class="separator" v-if="boxView && responseTime.value"/>
    <div class="hp-card perf-card position-relative">
      <div class="perf-card__head">{{ nps }} NPS</div>
      <div>
        Recommended: <span class="has-text-weight-bold color-blue-v2">{{ npsRecommendation(nps) }}</span>
      </div>
      <tooltip :iconRight="npsTooltipIconRightPos" :iconTop="6" :tooltipRight="npsTooltipRightPos" :tooltipTop="npsTooltipTopPos" cannedTooltip="nps" :openOnClick="true"/>
    </div>
  </div>
</template>
<script>
import {misc} from '@/mixins'
import Tooltip from "./Tooltip.vue";

export default {
  name: 'BizPerformance',
  props: {
    trustIndex: {
      type: Number,
      default: null
    },
    responseTime: {
      type: Object,
      default () {
        return {value: 0, unit: ''}
      }
    },
    nps: {
      type: Number,
      default: 0
    },
    industries: {
      type: Array,
      default () {
        return []
      }
    },
    boxView: {
      type: Boolean,
      default: false
    },
  },
  mixins: [misc],
  components: {
    Tooltip
  },
  computed: {
    rankTooltipIconRightPos () {
      return this.boxView ? 0 : this.isMobile ? 10 : 6
    },
    rankTooltipRightPos () {
      return this.boxView ? 6 : 16
    },
    rankTooltipTopPos () {
      return this.isMobile ? 20 : 60
    },
    npsTooltipIconRightPos () {
      return this.boxView ? 0 : 6
    },
    npsTooltipRightPos () {
      return this.boxView ? 6 : 16
    },
    npsTooltipTopPos () {
      return this.boxView ? 20 : 60
    },
    mainIndustry () {
      let obj = {}

      this.industries.every(elem => {
        if (elem.isMainIndus) {
          obj = elem
          return false;
        }
        return true
      })

      return obj
    },
    topIndustry () {
      const obj = {name: '', url: '', rank: ''}

      if (this.industries.length) {
        const slug = this.industries[0].slug
        obj.url = this.getIndustryDetailUrl(slug, this.industries[0].isMainIndus)

        obj.name = this.industries[0].name
        obj.rank = this.industries[0].industryRanking
      }
      return obj
    },
    industryRankingTooltipHtml () {
      let html = ''
      if (this.industries.length > 1) {
        this.industries.slice(1).forEach(elem => {
          const link = this.getIndustryDetailUrl(elem.slug, elem.isMainIndus)
          html += `<div class="margin-bottom-5"><span class="has-text-weight-bold">#${elem.industryRanking}</span> in <a href="${link}" class="link--v2">${elem.name}</a></div>`
        })
      }
      return html
    },
  },
  methods: {
    getIndustryDetailUrl (slug, isMainIndus = false) {
      let link
      if (isMainIndus) {
        link = `/industries/${slug}`
      } else {
        link = `/industries/${this.mainIndustry.slug}/${slug}`
      }

      return link
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

.perf-card {
  width: 188px;
  margin: 0 10px 10px 0;
  padding: 7px 6px 9px 16px;
  font-size: 12px;
  height: 66px;

  &:last-child {
    margin-right: 0;
  }

  @include tablet {
    width: 160px;
    margin-right: 14px;
  }

  @include mobile {
    width: 100%;
    margin-right: 0;
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.05);
    border: 0.3px solid #c9c9ca;
    border-radius: 5px;
    font-size: 11px;
    display: flex;
    align-items: baseline;
    padding: 2px 0 0 13px;
    height: 30px;
    margin-bottom: 9px;

    *:not(.perf-card__head) {
      font-weight: normal !important;
    }
  }

  .perf-card__head {
    font-size: 20px;
    font-weight: bold;

    @include mobile {
      font-size: 14px;
      width: 60px;
    }
  }

  > > > .tooltip-icon {
    width: 14.3px;
    height: 14.3px;
    font-size: 9px;

    @include mobile {
      width: 13px;
      height: 14px;
    }
  }
}

.box-view {
  border-radius: 5px;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.05);
  border: 0.3px solid #c9c9ca;
  padding: 16px 18px 8px;

  .separator {
    background-color: map-get($colors, 'gray2');
    margin: 6px 0 7px;
    width: 100%;
    opacity: 0.1;
  }

  .hp-card {
    border: none;
    padding-left: 0;
    box-shadow: none;
    margin-bottom: -4px;
  }

  .perf-card__head {
    width: 70px;
  }
}
</style>
<style lang="scss">
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/vendor/_breakpoints.scss";

.rankingTooltip.tooltip.popover .popover-inner {
  padding-bottom: 9px;

  @include tablet {
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BizPerformance.vue